<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" CustomPageActions>
          <v-card class="px-3" :loading="loading">
            <v-row class="pa-0">
              <v-col cols="1" :class="`${arabic?'arFont':'enFont'}`">
                <v-icon color="primary">health_and_safety</v-icon>
              </v-col>
              <v-col cols="10" :class="`${arabic?'arFont':'enFont'}`">
                SYSTEM HEALTH
              </v-col>
              <v-col cols="1" :class="`${arabic?'arFont':'enFont'}`">
                <v-btn x-small color="success" :class="`${arabic?'arFont':'enFont'}`" @click="init()">{{i18n.reload}}</v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" Details>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0 align-center mb-1">
                <v-col cols="12" class="py-0">
                  <v-row class="pa-0 align-center mb-1">
                    <v-col cols="2" :class="`${arabic?'arFont':'enFont'}`">
                      Q STATUS
                    </v-col>
                    <v-col cols="2" :class="`${arabic?'arFont':'enFont'}`">
                      DELAYED: {{q.delay}}
                    </v-col>
                    <v-col cols="7" :class="`${arabic?'arFont':'enFont'}`">
                      ALL: {{q.all}}
                    </v-col>
                    <v-col cols="1" :class="`${arabic?'arFont':'enFont'}`">
                      <v-btn x-small color="success" :class="`${arabic?'arFont':'enFont'}`" :loading="subloading" @click="getQstatus()">{{i18n.reload}}</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-row class="pa-0 align-center mb-1">
                    <v-col cols="2" :class="`${arabic?'arFont':'enFont'} py-0 my-0`">
                      SUB Qs
                    </v-col>
                    <v-col cols="10" :class="`${arabic?'arFont':'enFont'} py-0 my-0`">
                      <v-row class="pa-0 align-center" v-for="(q, i) in q.details.filter(x=>parseInt(x.delay)>2)" :key="'q-'+i">
                        <v-col cols="4" :class="`${arabic?'arFont':'enFont'} py-0 my-0`" style="text-transform:uppercase;">
                          {{q.q}}
                        </v-col>
                        <v-col cols="2" :class="`${arabic?'arFont':'enFont'} py-0 my-0`">
                          DELAYED: {{q.delay}}
                        </v-col>
                        <v-col cols="4" :class="`${arabic?'arFont':'enFont'} py-0 my-0`">
                          ALL: {{q.all}}
                        </v-col>
                        <v-col cols="1" :class="`${arabic?'arFont':'enFont'} py-0 my-0`">
                          <v-btn x-small color="error" text :class="`${arabic?'arFont':'enFont'}`" :loading="subloading" @click="clearQ(q.q)">clear q</v-btn>
                        </v-col>
                        <v-col cols="1" :class="`${arabic?'arFont':'enFont'} py-0 my-0`">
                          <v-btn x-small color="success" :class="`${arabic?'arFont':'enFont'}`" :loading="subloading" @click="getQstatus()">{{i18n.reload}}</v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-row class="pa-0 align-center mb-1">
                    <v-col cols="2" :class="`${arabic?'arFont':'enFont'}`">
                      CRM SERVER
                    </v-col>
                    <v-col cols="9" :class="`${arabic?'arFont':'enFont'}`">
                      CHECK: {{crm.status}}
                      <v-avatar
                        size="10"
                        class="mx-1"
                        :color="`${crm.status ? 'success' : 'error'}`"
                      >
                      </v-avatar>
                    </v-col>
                    <v-col cols="1" :class="`${arabic?'arFont':'enFont'}`">
                      <v-btn x-small color="success" :class="`${arabic?'arFont':'enFont'}`" :loading="subloading" @click="crmServer()">{{i18n.reload}}</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-row class="pa-0 align-center mb-1">
                    <v-col cols="2" :class="`${arabic?'arFont':'enFont'}`">
                      EMAIL SERVER 1
                    </v-col>
                    <v-col cols="9" :class="`${arabic?'arFont':'enFont'}`">
                      CHECK: {{email.status}}
                      <v-avatar
                        size="10"
                        class="mx-1"
                        :color="`${email.status ? 'success' : 'error'}`"
                      >
                      </v-avatar>
                    </v-col>
                    <v-col cols="1" :class="`${arabic?'arFont':'enFont'}`">
                      <v-btn x-small color="success" :class="`${arabic?'arFont':'enFont'}`" :loading="subloading" @click="emailServer()">{{i18n.reload}}</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-row class="pa-0 align-center mb-1">
                    <v-col cols="2" :class="`${arabic?'arFont':'enFont'}`">
                      EMAIL SERVER 2
                    </v-col>
                    <v-col cols="9" :class="`${arabic?'arFont':'enFont'}`">
                      CHECK: {{de.status}}
                      <v-avatar
                        size="10"
                        class="mx-1"
                        :color="`${de.status ? 'success' : 'error'}`"
                      >
                      </v-avatar>
                    </v-col>
                    <v-col cols="1" :class="`${arabic?'arFont':'enFont'}`">
                      <v-btn x-small color="success" :class="`${arabic?'arFont':'enFont'}`" :loading="subloading" @click="deServer()">{{i18n.reload}}</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-row class="pa-0 align-center mb-1">
                    <v-col cols="2" :class="`${arabic?'arFont':'enFont'}`">
                      Zoom Status
                    </v-col>
                    <v-col cols="9" :class="`${arabic?'arFont':'enFont'}`">
                      CHECK:
                      <span v-for="(z, i) in zoom" :key="'zoom'+i">
                        <v-avatar
                          size="12"
                          class="mx-1"
                          :color="`${z.busy ? 'error' :  'success'}`"
                        >
                          <span style="font-size:9px;color:white;">{{z.id}}</span>
                        </v-avatar>
                      </span>
                    </v-col>
                    <v-col cols="1" :class="`${arabic?'arFont':'enFont'}`">
                      <v-btn x-small color="success" :class="`${arabic?'arFont':'enFont'}`" :loading="subloading" @click="getZoom()">{{i18n.reload}}</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-row class="pa-0 align-center mb-1">
                    <v-col cols="2" :class="`${arabic?'arFont':'enFont'}`">
                      WA Status
                    </v-col>
                    <v-col cols="9" :class="`${arabic?'arFont':'enFont'}`">
                      CHECK:
                      <div v-for="(w, r) in wasettings" :key="'wa'+r" class="px-2">
                        <v-avatar
                          size="10"
                          class="mx-1"
                          :color="`${w.status ? 'success' :  'error'}`"
                        >
                        </v-avatar>
                        <v-btn x-small color="success" :class="`${arabic?'arFont':'enFont'}`" text :loading="waloading" @click="checkSessionStatus(w, r)">{{w.country}} | {{w.number}} | {{w.count}} | {{w.instance.replace('https://', '').replace('.aramccowa.com/api', '')}}</v-btn>
                      </div>
                    </v-col>
                    <v-col cols="1" :class="`${arabic?'arFont':'enFont'}`">
                      <v-btn x-small color="success" :class="`${arabic?'arFont':'enFont'}`" :loading="subloading" @click="loadWA()">{{i18n.reload}}</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import multiDialog from '@/components/multiDialog'
import ZoomPanel from '@/components/ZoomPanel'
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import { storageRef, firebase, db, auth, store } from '@/fb';
import axios from 'axios';
const headers = {'Accept': 'application/json'};
let api_fire_base = 'https://us-central1-aramcco-crm.cloudfunctions.net/main'

export default {
  components: { Search, Paging, multiDialog, ZoomPanel },
  data() {
    return {
      loading:false,
      subloading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        
      ],
      resourceSettings:{
        resourceName:null,
        search:true,
        create:true,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      q:{},
      crm:{},
      email:{},
      de:{},
      zoom:[],
      waloading:false,
      wasettings:[],
    }
  },
  methods: {
    async clearQ(s) {
      return new Promise (async (res, rej)=>{
        this.loading = true
        let country = s.toLowerCase().replace('WA', '').replace('wa', '')
        let r = await axios.get(`https://aramccocrm.com/api/v1/clear-queue/${country}`).then(x=>x.data)
        this.$emit('snackbarNotification', `Clear`, 'success')
        this.loading = false
      })
    },
    async getQstatus(){
      return new Promise(async (res, rej)=>{
        this.subloading = true
        this.q = {}
        this.q = await this.$store.dispatch('getResource', {resource:'/qstatus'})
        this.subloading = false
        res()
      })
    },
    async crmServer(){
      return new Promise(async (res, rej)=>{
        this.subloading = true
        this.crm = {}
        this.crm = await axios.get('https://aramccocrm.com/api/v1/system-check').then(x=>x.data)
        this.subloading = false
        res()
      })
    },
    async emailServer(){
      return new Promise(async (res, rej)=>{
        this.subloading = true
        this.email = {}
        this.email = await axios({
            method: 'get',
            url: 'https://aramcogermany.com/api/v1/system-check',
            timeout: 4000 // only wait for 2s
        }).then(x=>x.data)
        .catch(res())
        this.subloading = false
        res()
      })
    },
    async deServer(){
      return new Promise(async (res, rej)=>{
        this.subloading = true
        this.de = {}
        this.de = await axios.get('https://arramccogermany.com/api/v1/system-check').then(x=>x.data)
        this.subloading = false
        res()
      })
    },
    async getZoom(){
      return new Promise(async (res, rej)=>{
        this.subloading = true
        this.zoom = []
        let d = await axios.get('https://aramccocrm.com/api/v1/zoom').then(x=>x.data)
        this.zoom = d.data
        this.subloading = false
        res()
      })
    },
    async checkSessionStatus(s, i) {
      return new Promise (async (res, rej)=>{
        this.waloading = true
        this.wasettings[i].status = false
        var config = {
          url: `${s.instance}/aramcco${s.id}/check-connection-session`,
          method: 'get',
          headers: { 
            'Authorization': 'Bearer ' + s.token
          }
        };
        const axios_new = axios.create();
        let r = await axios_new(config).then(x=>x.data)
        .catch((error)=> {
          this.waloading = false
          this.wasettings[i].status = false
          console.log(error);
        });
        console.log(r)
        if(r) {
          this.waloading = false
          this.wasettings[i].status = r.status
          console.log(this.wasettings[i], this.wasettings[i].id, this.wasettings[i].status)
          // this.$emit('snackbarNotification', `STATUS: ${r.status} | ${r.message}`, 'success')
        } else {
          this.wasettings[i].status = false
          this.waloading = false
        }
        res(r)
      })
    },
    async loadWA(){
      return new Promise(async (res, rej)=>{
        this.waloading = true
        let a = await db.ref(`settings/newwa/numbers`).once('value').then(x=>x.val())
        let settings = a ? 
          Object.values(a)
          .map((x, i)=>{return{...x,key:Object.keys(a)[i],status:false}})
          .sort( (a, b)=> a.country > b.country ? -1 : 1 )
          : []
        console.log(settings)
        this.wasettings = settings;
        (async x=>{
          for (let i = 0; i < this.wasettings.length; i++) {
            const s = this.wasettings[i];
            await this.checkSessionStatus(s, i)
          }
        })()
        this.waloading = false
        res(true)
      })
    },
    async init(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.getQstatus()
        await this.crmServer()
        await this.emailServer()
        await this.deServer()
        await this.getZoom()
        this.loading = false
        await this.loadWA();
        
        res(true)
      })
    },
    clipboardSuccessHandler (){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler () {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    editLead(r){
      this.dialog = true
      this.editing = true
      this.newResource = r
    },
    async loadItems(){
      return new Promise(async (res, rej)=>{
        let ks = this.resourceKeys.filter(x=>x.type=='select' && x.source == 'db');
        (async x=> {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            console.log(f.items)
            f.data = this.resource[f.items].map(x=>{
              return {
                ...x,
                text:x.name?x.name:x.en?x.en:x.email?x.email:'unknown',
                [`${f.name}_id`]:x.id
              }
            })
          }
          res(true)
        })()
      })
    },
    superA(){
      return this.$store.state.user && this.$store.state.user.role == 'superadmin'
    },
    getFormat(d){
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        }
        this.loading = false
        await this.loadItems()
        res(true)
      })
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${n}`})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
        }
        this.loading = false
        res(true)
      })
    },
    async searchResource(search){
      return new Promise(async (res, rej)=>{
        this.search = search
        this.loading = true
        this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        this.loading = false
        res(true)
      })
    },
    async updateResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(r)
        await this.$store.dispatch('putResource', {resource:this.$route.path + `/${r.id}`, value:r})
        this.dialog = false
        this.editing = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
        res(true)
      })
    },
    async deleteResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('deleteResource', {resource:this.$route.path + `/${r.id}`})
        this.dialog = false
        this.deleting = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
        res(true)
      })
    },
    async registerToFire(candidate){
      return new Promise(async (res, rej)=>{
        let user = {
          name:candidate.name,
          email:candidate.email,
          password: randomString(8, '#Aa')
        }
        let a = await axios.post(`${api_fire_base}/registerNewUser`, user, {headers:headers}).then(x=>x.data)
        .catch(error => console.log(error))
        res({...user, ...a.user})
      })
    },
    async postResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(JSON.stringify(r))
        let user = await this.registerToFire(r)
        r.generated_password = user.password
        r.google_uid = user.uid
        this.generated_user = user
        await this.$store.dispatch('postResource', {resource:this.$route.path + `${r.id ? '/' + r.id : ''}`, value:r})
        this.dialog = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
        res(true)
      })
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.$route.path.replace('/', '')
    },
    
  },
  watch:{
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.setResourceName()
    await this.init()
  },
  
}
</script>

<style>
.adminSwitch .v-input {
  margin-top:0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom:0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>